import metricsStore from '@src/globalStore/metricsStore';
import { CURRENT_PRODUCT_MODE, isAppModule } from '@utils/constants';

export enum AI_ALERT_TYPE {
  SPIKE = 'SPIKE',
  DIP = 'DIP',
}

export function useGetAIAlertType(alertMetricName) {
  if (!isAppModule) {
    // Default to SPIKE for Video and AD
    // TODO, some video metrics don't have reverse
    return AI_ALERT_TYPE.SPIKE;
  }
  const { metricsMeta } = metricsStore.getState();
  const currentProductMetrics = metricsMeta[CURRENT_PRODUCT_MODE.toLowerCase()] || {};
  const curMetric = currentProductMetrics[alertMetricName] || {};
  return curMetric.reverse ? AI_ALERT_TYPE.SPIKE : AI_ALERT_TYPE.DIP;
}
